var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":_vm.color,"tile":_vm.tile}},[_c('v-sheet',{class:_vm.contentClasses ?
      ("mx-auto " + _vm.contentClasses) :("mx-auto py-6 px-6 " + (!_vm.dense ? 'py-md-12' : 'py-md-6')),attrs:{"max-width":"1264","color":_vm.color,"tile":_vm.tile}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }